// extracted by mini-css-extract-plugin
export default {"MonthText":"monthText_MonthText__n+BqP","monthNum":"monthText_monthNum__8jh6p","monthString":"monthText_monthString__-HRlZ"};